/**
 * Dashboard API Module
 * API calls for dashboard statistics and overview data
 */

import apiClient from '@/lib/api-client'

export interface DashboardStats {
  tenants: {
    total: number
    active: number
    growth: number
  }
  organizations: {
    total: number
    active: number
    growth: number
  }
  users: {
    total: number
    active: number
    growth: number
  }
  agents: {
    total: number
    active: number
    growth: number
  }
  tokens: {
    consumed: number
    growth: number
  }
}

export interface DashboardResponse {
  success: boolean
  data: DashboardStats
}

export const dashboardApi = {
  /**
   * Get dashboard statistics
   */
  getStats: async (): Promise<DashboardResponse> => {
    const { data } = await apiClient.get<DashboardResponse>('/v1/dashboard/stats')
    return data
  },
}
